import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Logo } from './style';

const Card = ({ children }) => (
  <Wrapper>
    <Logo src="images/robin-logo.svg" alt="Robin" />
    {children}
  </Wrapper>
);

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Card;
